import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy, AfterViewInit, ElementRef, ViewChildren, Query, QueryList, DoCheck, OnChanges } from '@angular/core';
import { HomeService } from '../../framework/services/home.service';
import { ignoreElements } from 'rxjs/operators';
import { log } from 'util';
import { FilterUtils } from 'primeng/utils';
import { Table, SelectItem } from 'primeng';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { stringify } from 'querystring';
import { getLocaleMonthNames } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from '../shared/app-constants/category-constants';
import { AppConfigService } from 'src/framework/services/app-config.service';
import { CommonService } from 'src/framework/services/common.service';
//import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import {MsalService} from '@azure/msal-angular'
// import { Table } from 'primeng/table';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
  ,
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck {
  @ViewChild('dt') public _table: Table;
  @ViewChildren('filter') public filter: QueryList<ElementRef>;
  cols: any[];
  initialDate: string;
  modifiedDate: string;
  incomingDate: Date;
  engagementList: any[];
  pastEngagementList: any[];
  maxDateSelected = new Date();
  selectedItem: string;
  filterTemp: any[];
  numberArray: any[];
  NameAndDesc: string;
  roles: any[];
  status: any[];
  juridication: any[];
  selectedLanguageId: number;
  selectedEngagement: any;
  MappedLanguage = [];
  userData: any;
  MappedEnglishLanguage = [];
  data: { name: string; };
  loggedIn: boolean = false;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  isDocnavClicked: boolean = false;
  globalSearchFilter: string = "";
  isLoadComplete: boolean = false;
  queryParameter: string = "";
  filterElement: HTMLInputElement;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  localeSetting: any;
  approvalCount: number = 0;

  constructor(private service: HomeService, private router: Router, private routes: ActivatedRoute, private changes: ChangeDetectorRef, private languageService: LanguageService, private spinner: NgxSpinnerService, private appService: AppConfigService, private commonService: CommonService, private msalService: MsalService) {
    this.maxDateSelected.setDate(this.maxDateSelected.getDate());
  }
  ngOnInit() {
    if (this.msalService.instance.getActiveAccount()!= null) {
      this.commonService.getUserApprovalCount().subscribe((response: any) => {
        this.approvalCount = parseInt(response.data);
      })
    }

    this.isLoadComplete = false;

    this.selectedEngagement = "active"
    this.loadLanguageLabel();
    if (sessionStorage.getItem('selectedLanguageId')) {
      this.selectedLanguageId = JSON.parse(sessionStorage.getItem('selectedLanguageId'));
    }
    this.languageService.currentData.subscribe(data => this.selectedLanguageId = data.Id);
    this.roles = [];
    this.juridication = [];
    this.languageService.userData.subscribe((data) => {
      this.userData = data.data;
      if (this.userData) {
        this.loggedIn = true;
        this.cols = this.getHomeGridColumns(true);
        this.getEngagementListbasedonTabsSelected(true);

      }
      else {
        this.cols = this.getHomeGridColumns(false);
        var indexes = -1;
        indexes = this.cols.findIndex(x => x.header === "Status");
        this.loggedIn = false;
        if (indexes != -1) {
          this.cols.splice(indexes, 1)

        }
      }
    });
    FilterUtils['numberInBetween'] = (value: string, filter: [Date, Date]) => {
      this.incomingDate = new Date(value);
      if (filter === undefined || filter === null) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      var dateserch = this.incomingDate.toISOString().slice(0, 10);
      var incomdate = new Date(dateserch);
      var filterdateto = this.dateAsYYYYMMDDHHNNSS(filter[1]);
      var toDate = new Date(filterdateto);
      var filterDateFrom = this.dateAsYYYYMMDDHHNNSS(filter[0]);
      var FromDate = new Date(filterDateFrom);
      return incomdate.getTime() >= FromDate.getTime()
        && incomdate.getTime() <= toDate.getTime();

    };
    this.routes.queryParams.subscribe(params => {
      if (params.engagementType) {

        this.selectedEngagement = params.engagementType;

        if (this.selectedEngagement == "active") {

          this.service.setIsHomeSelected(true)
          this.getEngagementListbasedonTabsSelected(true);
          this.isLoadComplete = false;
        }
        else {
          this.getEngagementListbasedonTabsSelected(false);
          this.isLoadComplete = false;
        }
      }
    });
    this.languageService.currentData.subscribe(data => {
      this.data = data;
      this.selectedLanguageId = data.Id;
      if (this.selectedEngagement == "active") {
        this.getEngagementListbasedonTabsSelected(true);
        this.isLoadComplete = false;
      }
      else {
        this.getEngagementListbasedonTabsSelected(false);
        this.isLoadComplete = false;
      }

    });
    this.languageService.currentData.subscribe(data => this.data = data);
  }


  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise<void>((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.DocumentCentre.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];


          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.DocumentCentre.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.DocumentCentre.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }
          if (selectedLanguageMappings != undefined) {
            this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);
            this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings.languageMappingJSON);
            this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON);
          }
          else {
            this.selectedAppLanguageJson = JSON.parse(englishLanguageMappings.languageMappingJSON);
            this.selectedLangStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);
            this.selectedLangDateJson = JSON.parse(englishDateMappings?.languageMappingJSON);

          }

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.setCalendarLocale();


          this.cols = [
            { field: 'name', header: this.labelReplacer('EngagementName') },
            { field: 'modifieddatestringformat', header: this.labelReplacer('LastUpdatedOn') },
            { field: 'initialdatestringformat', header: this.labelReplacer('InitialDate') },
            { field: 'engagementRoleName', header: this.labelReplacer('OurRole') },
            { field: 'jurisdictionOfFilingName', header: this.labelReplacer('JurisdictionOfFiling') }
          ];
          this.status = [
            { label: 1, value: this.statusReplacer(1) },
            { label: 2, value: this.statusReplacer(2) },
            { label: 3, value: this.statusReplacer(3) }
          ];
          if (this.userData) {
            this.cols.push({ field: 'statusId', header: this.labelReplacer('Status') })
          }
          this.islabelLoaded = true;
          resolve();
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  monthReplacer(labelKey): string {
    let localeDt;
    if (labelKey) {
      let arr = labelKey.split(' ');
      if (arr?.length == 3)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2];
      else
        localeDt = labelKey;
    }
    return localeDt;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);

    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }

  dateAsYYYYMMDDHHNNSS(date): string {
    return date.getFullYear()
      + '-' + this.leftpad(date.getMonth() + 1, 2)
      + '-' + this.leftpad(date.getDate(), 2);
  }

  getJurisdiction(engagementList) {
    if (engagementList?.length > 0) {
      var names = engagementList.map(function (item) {
        return { 'label': item.jurisdictionOfFilingName, 'value': item.jurisdictionOfFilingName }
      });

      const filteredArr = names.reduce((acc, current) => {
        const x = acc.find(item => item.label === current.label);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      this.juridication = filteredArr;
    }

  }

  getRoles(engagementList) {
    if (engagementList?.length > 0) {
      var rolenames = engagementList.map(function (item) {
        return { 'label': item.engagementRoleName, 'value': item.engagementRoleName }
      });

      const filteredRoleArr = rolenames.reduce((acc, current) => {
        const x = acc.find(item => item.label === current.label);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      this.roles = filteredRoleArr;
    }

  }

  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  leftpad(val, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength)
      + String(val)).slice(String(val).length);
  }

  applyFilter(event, dt) {
    if (this.initialDate != null && this.initialDate != "") {
      dt.filter([this.initialDate[0], this.initialDate[1]], 'initialdatestringformat', 'numberInBetween');
    }
  }

  applyFilterForModifiedDate(event, dt) {
    if (this.modifiedDate != null && this.modifiedDate != "") {
      dt.filter([this.modifiedDate[0], this.modifiedDate[1]], 'modifieddatestringformat', 'numberInBetween');
    }
  }


  getColor(status) {
    switch (status) {
      case "Draft":
        return "#747480";
      case "Taken Down":
        return "#ff4136";
      case "Live":
        return "#2db757";
    }
  }


  getEngagementListbasedonTabsSelected(tabs) {
    this.spinner.show();
    // if (this._table)
    //   this._table.reset();
    this.modifiedDate = "";
    this.initialDate = "";
    if (!tabs) {
      if (!this.userData || this.userData.isActive == false) {
        this.engagementList = [];
        this.service.GetPastEngagementsForExternalUser(this.selectedLanguageId).subscribe((resp) => {
          this.engagementList = resp;
          this.filterTemp = this.engagementList;
          this.getJurisdiction(this.engagementList);
          this.getRoles(this.engagementList);
          this.getStatus(this.engagementList);
          this.addCustomColumn();
          this.spinner.hide();
        });
      }
      else if (this.userData && this.userData.isActive == true) {
        this.service.getPastEngagementList(this.selectedLanguageId).subscribe((resp) => {
          this.engagementList = [];
          if (this.userData.rankCode == 11 || this.userData.rankCode == 13 || this.userData.rankCode == 21 || this.userData.isAdmin == true) {
            this.engagementList = resp;
            this.filterTemp = this.engagementList;
          }
          else {
            if (resp && resp.length > 0) {
              this.engagementList = resp.filter(item => item.isConfidential != 1);
              this.filterTemp = this.engagementList;
            }
          }
          this.getJurisdiction(this.engagementList);
          this.getRoles(this.engagementList);
          this.getStatus(this.engagementList)
          this.addCustomColumn();
          this.spinner.hide();
        });
      }

    }
    else {
      if (!this.userData || this.userData.isActive == false) {
        this.engagementList = [];
        this.service.GetEngagementsForExternalUser(this.selectedLanguageId).subscribe((resp) => {
          this.engagementList = resp.data;
          this.filterTemp = this.engagementList;
          this.getJurisdiction(this.engagementList);
          this.getRoles(this.engagementList);
          this.getStatus(this.engagementList);
          this.addCustomColumn();
          this.spinner.hide();
        });
      }
      else if (this.userData && this.userData.isActive == true) {
        this.service.getEngagementList(this.selectedLanguageId).subscribe((resp) => {
          this.engagementList = [];
          if (this.userData.rankCode == 11 || this.userData.rankCode == 13 || this.userData.rankCode == 21 || this.userData.isAdmin == true) {
            this.engagementList = resp.data;
            this.filterTemp = this.engagementList;
          }
          else {
            if (resp.data && resp.data.length > 0) {
              this.engagementList = resp.data.filter(item => item.isConfidential != 1);
              this.filterTemp = this.engagementList;
            }
          }
          this.getJurisdiction(this.engagementList);
          this.getRoles(this.engagementList);
          this.getStatus(this.engagementList);
          this.addCustomColumn();
          this.spinner.hide();
        });
      }
    }
  }

  addCustomColumn() {
    if (this.engagementList && this.engagementList.length)
      this.engagementList.forEach(element => {
        element.EngWithDesc = element.name + ' ' + element.description;
      });
  }


  GetEngagementsForExternalUser(languageId) {
    this.service.GetEngagementsForExternalUser(languageId).subscribe((resp) => {
      this.engagementList = resp.data;
      this.filterTemp = this.engagementList;
      this.addCustomColumn();
    });
  }

  GetPastEngagementsForExternalUser(languageId) {
    this.service.GetPastEngagementsForExternalUser(languageId).subscribe((resp) => {
      this.engagementList = resp.data;
      this.filterTemp = this.engagementList;
      this.addCustomColumn();
    });
  }

  filterBy(filtercomponent: string) {
    this.selectedItem = filtercomponent;
    this.engagementList = this.filterTemp;
    this.engagementList = this.engagementList.filter((x) => ((x.name.startsWith(filtercomponent)) || (x.name.startsWith(filtercomponent.toLocaleLowerCase()))));

  }

  filterNumber(filtercomponent) {
    this.selectedItem = filtercomponent;
    this.engagementList = this.filterTemp;
    this.engagementList = this.engagementList.filter((item) => (item.name.match(/^\d/)));
  }

  clearFilter(filtercomponent) {
    this.selectedItem = filtercomponent;
    this.engagementList = this.filterTemp;
  }



  getColorBasedOnConfidentiality(isFormal, status) {

    if (isFormal == false) {
      return "#cdcdcd";
    }
    else if (isFormal == true) {
      if (status == 'Taken Down' || status == 'Draft') {
        return "#ffe600";
      }
    }
  }

  getPastEngagementList(): any {
    this.service.getPastEngagementList(this.selectedLanguageId).subscribe
      (
        (resp) => {
          this.filterTemp = resp;
          this.addCustomColumn();
          return resp;
        }
      );
  }
  clickHandler(anchor) {
    var hasClass = anchor.getAttribute('class');
    if (hasClass !== 'active') {
      anchor.setAttribute('class', 'active');
    }
  }

  getStatusPillClass(status) {
    let pillClass = '';
    if (status.toLowerCase() === 'live')
      pillClass = 'pill pill--approved';
    else if (status.toLowerCase() === 'draft')
      pillClass = 'pill pill--closed';
    else if (status.toLowerCase() === 'taken down')
      pillClass = 'pill pill--failed';
    else if (status.toLowerCase() === 'authorized' || status.toLowerCase() === 'deleted')
      pillClass = 'pill pill--hold';

    return pillClass;
  }

  navigateToEdit(engagementData) {
    var newElement = document.getElementById("engagement_nav");
    if (newElement) {
      newElement.classList.remove("active");
      newElement.classList.remove("show");
    }
    var newElements = document.getElementById("addEngagement");
    if (newElements) {
      newElements.classList.remove("active");
    }
    this.changes.detectChanges();
    sessionStorage.setItem('engagementData', JSON.stringify(engagementData));
    this.router.navigate(['/edit-engmt'])
    // this.router.navigate(['/engagement-mgt'])
  }

  navigateToDetail(engagementData) {
    // if(engagementData.statusName.toLowerCase()  == 'live')
    // {
    var newElement = document.getElementById("engagement_nav");
    if (newElement) {
      newElement.classList.remove("active");
      newElement.classList.remove("show");
    }
    var newElements = document.getElementById("addEngagement");
    if (newElements) {
      newElements.classList.remove("active");
    }
    sessionStorage.setItem('engagementData', JSON.stringify(engagementData));
    // this.router.navigate(['/detail-engmt'])
    // }
    this.router.navigate(['/detail-engmt'], { queryParams: { 'eid': engagementData.engagementId } });
  }
  ngOnDestroy() {
    this.service.setIsHomeSelected(false);
  }

  getStatus(engagementList) {
    if (engagementList?.length > 0) {
      var rolenames = engagementList.map(function (item) {
        return { 'label': item.statusId, 'value': item.statusId }
      });

      const filteredRoleArr = rolenames.reduce((acc, current) => {
        const x = acc.find(item => item.label === current.label);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      filteredRoleArr.forEach(item => {
        item.label = this.statusReplacer(item.label);
      }
      );
      this.status = filteredRoleArr;

    }

  }

  getHomeGridColumns(isAuthenticated: boolean): any[] {
    let cols = [];
    if (this.selectedAppLanguageJson) {
      cols =
        [
          { field: 'name', header: this.labelReplacer('EngagementName') },
          { field: 'modifieddatestringformat', header: this.labelReplacer('LastUpdatedOn') },
          { field: 'initialdatestringformat', header: this.labelReplacer('InitialDate') },
          { field: 'engagementRoleName', header: this.labelReplacer('OurRole') },
          { field: 'jurisdictionOfFilingName', header: this.labelReplacer('JurisdictionOfFiling') }
        ]
      if (isAuthenticated) {
        cols.push({ field: 'statusId', header: this.labelReplacer('Status') })
      }
    }
    else {
      cols =
        [
          { field: 'name', header: 'Engagement Name' },
          { field: 'modifieddatestringformat', header: 'Last Updated On' },
          { field: 'initialdatestringformat', header: 'Initial Date' },
          { field: 'engagementRoleName', header: 'Our Role' },
          { field: 'jurisdictionOfFilingName', header: 'Jurisdiction Of Filing' }
        ]
      if (isAuthenticated) {
        cols.push({ field: 'statusId', header: 'Status' })
      }

    }
    return cols;
  }

  ngAfterViewInit() {

    this.filter.changes.subscribe((x: QueryList<ElementRef>) => {
      if (!this.isLoadComplete) {
        this.filterElement = x.first.nativeElement;
        this.filterElement.value = '';
        this.isLoadComplete = true;
      }
    })
  }

  ngDoCheck() {
    if (this.filterElement && !this.isLoadComplete) {
      //this.filterElement.value = "";
      this.isLoadComplete = true;
    }
  }

  loadApprovalManagement() {
    this.router.navigateByUrl("/approval-mgt?navigateTo=approval");
  }

}
